import Param from '../../param';
import effectManager from '../effect';
import YoutubeManager from '../libs/youtube';

let param = new Param();
const effect = new effectManager();

/* ---------------------------------------

    -- コラムのモーダル周りを制御

--------------------------------------- */

export default class ModalManager{
    constructor(scroll){

        this.scroll = scroll;

        this.w = window.innerWidth;

        this.$container = $(".l-modal");
        this.$trigger =  $(".js__modal-trigger");
        this.$target =  $(".js__modal-target"); /* モーダル内のコンテンツ 選択したものによって切り替える */
        this.$close = $(".l-modal-closebtn");/* 表示しているモーダルのクローズボタンを突っ込む */
        this.$closeFixed = "";/* 表示しているモーダルのクローズボタンを突っ込む */

        this.status = {
            select : {
                parent :"",
                modal : "",
                $content : ""
            },
            closeBtnSize:{
                w :   this.$close.innerWidth(),
                h :   this.$close.innerHeight(),
            },
            offset:{
              x : 0 /* モーダルの位置※閉じるボタンの位置計算用 */
            },
            flg : false, /* [ モーダルがオープン状態か ] */
            mouseFlg : false,  /* [ マウスのレンダリングをONにするか ] */
            linkMouseOn:false, /* [ モーダル内のリンクにマウスオンしているか ] */
            scrollInc : 0, /* [ モーダルをオープンにした際のスクロール位置を保持 ] */
            scrollLimit : 0, /* [ モーダルをオープンにした際のスクロール領域の高さを保持 ] */
            closeBtnFlg : false, /*  [ クローズボタンが表示されているか ] */
        }

        this.defaultCompanyTable = $('#p-company-content-info__inner table').html();
        this.addCompanyTable = $('#p-company-detail table').html();
        this.accordionFlg = false;

    }
    init(pageID){

        this.pageID = pageID;

        this.w = window.innerWidth;

        this.$container = $(".l-modal");
        this.$trigger =  $(".js__modal-trigger");
        this.$target =  $(".js__modal-target"); /* モーダル内のコンテンツ 選択したものによって切り替える */
        this.$close = $(".l-modal-closebtn");/* 表示しているモーダルのクローズボタンを突っ込む */
        this.$closeFixed = "";/* 表示しているモーダルのクローズボタンを突っ込む */

        this.status = {
            select : {
                parent :"",
                modal : "",
                $content : ""
            },
            closeBtnSize:{
                w :   this.$close.innerWidth(),
                h :   this.$close.innerHeight(),
            },
            offset:{
                x : 0 /* モーダルの位置※閉じるボタンの位置計算用 */
            },
            flg : false, /* [ モーダルがオープン状態か ] */
            mouseFlg : false,  /* [ マウスのレンダリングをONにするか ] */
            linkMouseOn:false, /* [ モーダル内のリンクにマウスオンしているか ] */
            scrollInc : 0, /* [ モーダルをオープンにした際のスクロール位置を保持 ] */
            scrollLimit : 0, /* [ モーダルをオープンにした際のスクロール領域の高さを保持 ] */
            closeBtnFlg : false, /*  [ クローズボタンが表示されているか ] */
        }

        this.defaultCompanyTable = $('#p-company-content-info__inner table').html();
        this.addCompanyTable = $('#p-company-detail table').html();
        this.accordionFlg = false;

        let _this = this;
        let _dbClick = false;

        /* business用 */
        this.$businessCover =  $("#p-business-rental-movie-view-cover >*");
        this.youtube = new YoutubeManager();

        effect.bg(this.$businessCover,"set");
        effect.show($(".js__modal-show"),"set");
        effect.closeBtn(this.$close.children(),"set");
        TweenMax.set(this.$target,{"display":"none"});

        /* news用 */
        this.$news = $("#p-news");
        this.$newsCover =  $("#p-news-cover >*");
        var ps = new PerfectScrollbar('#p-news__content');

        if(Useragnt.mobile){
            this.youtube.status.load=true;
            this.youtube.init();
        }

        this.$trigger.on("click",function () {
            
            if($(this).data('modal') === 'company' && param.displayType === 'sp'){
                _this.accordion(); return;
            }

            if(_dbClick||_this.status.flg) return;
            _dbClick = true;
            _this.status.mouseFlg = true;

            _this.status.select.parent = $(this).data("modal");
            _this.status.select.$modal = $("#js__modal-"+_this.status.select.parent);
            _this.status.select.$content =  $("#"+$(this).data("target"));

            TweenMax.set(_this.status.select.$content,{"display":"block"});

            if(_this.status.select.$content.attr("id") != "p-news") { //newsだけずらす
                _this.status.select.$modal.addClass("is-active");
            }
            _this.$closeFixed = _this.status.select.$modal.find(".l-modal-closebtn");
            effect.scShow($("#p-"+_this.status.select.parent+" .js__tsc-show"),"out");
            effect.panel($("#p-"+_this.status.select.parent+" .js__tsc-panel"),"out");

            setTimeout(function () {
                _this.resize();
            },1e2);

            /* 以下アニメーション */
            _this.$container.removeAttr('style');
            effect.show(_this.status.select.$modal.find(".js__modal-show"),"show");
            effect.closeBtn(_this.$closeFixed.children(),"show");
            if(param.displayType === 'sp'){
                TweenMax.to($("#l-header__inner,#l-header-logo"),0.2,{y:-60,ease:Power2.easeOut});
                TweenMax.to($("#l-pagetop,#l-scrolldown"),0.48,{
                    x:-300
                });
            }else{
                TweenMax.to($("#l-pagetop,#l-scrolldown"),0.48,{
                    x:300
                });
                TweenMax.to($("#l-header__inner,#l-header-logo"),0.4,{x:-300,ease:Power2.easeOut});
            }

            if(_this.status.select.$content.attr("id") == "p-business-rental-movie") {
                TweenMax.set($("#p-business-rental-movie-view-yt"),{ opacity:0 })
                TweenMax.set($("#p-business-rental-movie-view-cover"),{ display:'block' });
                effect.bg(_this.$businessCover,"show");
                setTimeout(()=>TweenMax.set($("#p-business-rental-movie-view-yt"),{ opacity:1 }),15e2);
                if(!_this.youtube.status.load){
                    _this.youtube.status.load=true;
                    _this.youtube.init();
                }else{
                    _this.youtube.player.seekTo(0);

                    setTimeout(()=>_this.youtube.player.playVideo(),2e3);
                }
                setTimeout(function () {
                    effect.bg(_this.$businessCover,"out");
                    TweenMax.set($("#p-business-rental-movie-view-cover"),{ delay:2,display:'none' });
                },2e3);
            }

            if($(this).data('modal') === 'news'){
                _this.newsOpen();
            }

            setTimeout(()=> _this.status.flg = true,1e3);
            setTimeout(()=> _dbClick = false,1e3);

        });

        /* モーダル閉じる */
        //_this.$container.on("click",function () {
        this.$container.on('click', function(event) {

            if(param.displayType === 'sp'){
                if(_this.status.linkMouseOn) return;
                if(!$(event.target).closest('#p-business-rental-movie').length && !$(event.target).closest('#p-business-rental-shop').length){
                    _this.close();
                }
            }else{
                _this.close();
            }
            if($(event.target).closest('#p-news').length){
                _this.newsClose();
            }

        });

        _this.$container.find("a,#p-business-rental-movie-view").hover(function () {
                _this.status.linkMouseOn = true;
            },
            function () {
                _this.status.linkMouseOn = false;
            }
        );

        _this.$container.find("a,#p-business-rental-movie-view").on('touchstart', function(event) {
            _this.status.linkMouseOn = true;
        });
        _this.$container.find("a,#p-business-rental-movie-view").on('touchend', function(event) {
            _this.status.linkMouseOn = false;
        });

    }

    update(current,type){ /* 状態監視 */
    }
    render(mouse,scinc){
        if(param.displayType !== 'sp') {
            this.status.scrollInc = scinc;
            TweenMax.set(this.$closeFixed, {
                x: mouse.x - this.status.closeBtnSize.w,
                y: mouse.y - this.status.closeBtnSize.h
            });
            if(!this.status.linkMouseOn){
                if(!this.status.closeBtnFlg){
                    this.status.closeBtnFlg = true;
                    effect.closeBtn(this.$closeFixed.children(),"show");
                }
            }else{
                if(this.status.closeBtnFlg){
                    this.status.closeBtnFlg = false;
                    effect.closeBtn(this.$closeFixed.children(),"out");
                }
            }
        }


    }

    accordion(){
        let $target = $('#p-company-content-info__inner');
        if(this.accordionFlg){
            this.accordionFlg = false;
            $target.find('table').html(this.defaultCompanyTable);
            $target.find('.c-btn-content-text').text('READ MORE');
            $target.find('.c-btn-content-arrow').removeClass('is-open');
        }else{
            this.accordionFlg = true;
            $target.find('table').html(this.addCompanyTable);
            $target.find('.c-btn-content-text').text('CLOSE');
            $target.find('.c-btn-content-arrow').addClass('is-open');
        }
        scroll.resize('top');
    }

    newsOpen(){
        effect.show($(".js__navi-show"),"out");
        effect.bg(this.$newsCover,"showset");
        TweenMax.set($("#js__modal-news"),{ display:'block' });
        $("#p-news__content").animate({ scrollTop:1  }, '1');
        $("#p-news__content").animate({ scrollTop:0  }, '1');
        setTimeout(() => {
            $('#js__modal-news').addClass('is-active');
            this.scroll.modalStatus.saveInc = this.scroll.nowInc;
            $('#l-root').removeAttr('style');
            $('body').addClass('is-hidden');
            this.scroll.status.stop = true;
            TweenMax.set(this.$news,{opacity:1});
            effect.bg(this.$newsCover,"out");
            TweenMax.fromTo($("#p-news__inner>.arrow"),0.6,{
                opacity:0
            } , {
                delay: 0.6,
                opacity:1,
                ease:Power2.easeOut
            });
        },1e3);
    }
    newsClose(){
        $('body').removeClass('is-hidden');
        effect.bg(this.$newsCover,"show");
        TweenMax.to($("#p-news__inner>.arrow"),0.6,{opacity:0,ease:Power2.easeOut});
        if(Useragnt.tablet)
                this.scroll.$htmlBody.animate({ scrollLeft:this.scroll.modalStatus.saveInc  }, '1');
            else
                this.scroll.$htmlBody.animate({ scrollTop:this.scroll.modalStatus.saveInc  }, '1');
        this.scroll.inc = this.scroll.modalStatus.saveInc;
        this.scroll.status.stop = false;
        this.scroll.pararax.init(param.displayType,param.scrollType);
        this.scroll.resize(this.pageID);
        setTimeout(() => {
            $('#js__modal-news').removeClass('is-active');
            TweenMax.set($("#js__modal-news"),{ delay: 1, display:'none' });
            effect.show($(".js__navi-show"),"set");
            effect.show($(".js__navi-show"),"show");
        },13e2);
    }

    close(){

        let _this = this;
        let _dbClick = false;

        if(_dbClick||!_this.status.flg||_this.status.linkMouseOn) return;
        _dbClick = true;

        if(_this.status.select.$content.attr("id") != "p-news") { //newsだけずらす
            _this.status.select.$modal.removeClass("is-active");
        }

        effect.show(_this.status.select.$modal.find(".js__modal-show"),"out");
        effect.closeBtn(_this.$closeFixed.children(),"out");

        if(_this.status.select.$content.attr("id") == "p-business-rental-movie") {
            effect.bg(_this.$businessCover,"show");
            _this.youtube.player.pauseVideo();
        }
        setTimeout(function () {
            effect.scShow($("#p-"+_this.status.select.parent+" .js__tsc-show"),"show");
            effect.panel($("#p-"+_this.status.select.parent+" .js__tsc-panel"),"show");
            _this.status.select.parent = "";
            TweenMax.to($("#l-scrolldown.is-active,#l-pagetop.is-active"),0.48,{
                x:0
            });
            TweenMax.to($("#l-header__inner,#l-header-logo"),0.4,{x:0,y:0,ease:Power2.easeOut});
            _this.status.flg = false
            _this.status.mouseFlg = false;

        },1e3);

        setTimeout(function () {
            TweenMax.set(_this.$target,{"display":"none"});
            _this.$closeFixed = "";
        },2e3);
        setTimeout(()=> _dbClick = false,1e3);
    }

    resize(){

        if(this.status.select.$content != ''){
            if(this.status.select.$content.attr("id") == 'p-news'){
                return;
            }
        }
        if(this.status.flg) this.close();
        this.w = window.innerWidth;
        this.status.closeBtnSize.w = this.$close.innerWidth()/2;
        this.status.closeBtnSize.h = this.$close.innerHeight()/2;
        if(this.status.flg){
            // this.status.offset.x = this.status.select.$modal.offset().left;
            if(this.status.select.parent!=="") TweenMax.set(this.status.select.$modal,{ x:this.status.scrollInc - this.w });
            if(this.youtube.status.load) this.youtube.resize();

        }




    }




}